import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import LoginView from '../components/LoginView';
import {withUser} from './AuthBase';
import {getPrimaryRoute} from '../../utils';

const Login = props => {
  const {history, currentUserLoading, currentUser} = props;
  const {
    location: {search},
  } = props.history;

  const [isRegistered, setIsRegistered] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (search.includes('email-verified')) {
      setIsRegistered(true);
    }
    setIsReady(true);
  }, [history, search]);

  if (!currentUserLoading && currentUser !== null) {
    history.push(getPrimaryRoute(currentUser.role));
  }

  const hideModal = () => {
    setIsRegistered(false);
    history.push({search: ''});
  };

  return (
    <div className="public-layout">
      <div className="login-layout">
        {isReady && !currentUserLoading && <LoginView {...props} isRegistered={isRegistered} hideModal={hideModal} history={history} />}
      </div>
    </div>
  );
};

Login.propTypes = {
  login: PropTypes.func,
  t: PropTypes.func,
  client: PropTypes.object,
  history: PropTypes.object,
  currentUser: PropTypes.object,
  currentUserLoading: PropTypes.bool.isRequired,
};

export default withUser(Login);
